import React, { useContext } from 'react';

/**
 * @typedef {object} ModalContext
 * @property {() => React.Dispatch<React.SetStateAction<string>>} closeModal - Function to close modal.
 * @property {string} modalName - Name of modal to display.
 * @property {React.Dispatch<React.SetStateAction<string>>} setModalName - Function to set modal name.
 */

export const ModalContext = React.createContext({});

/**
 * @returns {ModalContext}
 */
export const useModal = () => useContext(ModalContext);
